export const baseUrl = "https://apipresensi.alirsyadsolo.my.id";
export const loginUrl = `${baseUrl}/auth/login`;
export const dashboardUrl = `${baseUrl}/dashboard`;
export const biodataUrl = `${baseUrl}/biodata`;
export const jadwalUrl = `${baseUrl}/jadwal`;
export const presensiUrl = `${baseUrl}/presensi`;
export const riwayatIzin = `${baseUrl}/izin`;
export const riwayatDinas = `${baseUrl}/dinas`;
export const editBiodata = `${baseUrl}/biodata/edit`;
export const editPassword = `${baseUrl}/auth/change-password`;
export const getStatusIzin = `${baseUrl}/dashboard/jenisizin`;
export const createIzin = `${baseUrl}/izin/create/web`;
export const createDinas = `${baseUrl}/dinas/create`;
export const riwayatPresensiUrl = `${baseUrl}/laporan/presensi`;
export const rekapPresensiUrl = `${baseUrl}/rekap/presensi`;
